'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./RichMediaErrorOverlay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var RichMediaErrorOverlay = function RichMediaErrorOverlay(_ref) {
    var show = _ref.show;

    if (!show) return null;

    return _react2.default.createElement(
        'div',
        { className: 'RichMediaErrorOverlay' },
        _react2.default.createElement(_Icon2.default, { name: 'error-alert' }),
        'Sorry, this media cannot be played'
    );
};

// Styles


RichMediaErrorOverlay.propTypes = {
    show: _propTypes2.default.bool
};

exports.default = RichMediaErrorOverlay;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/RichMediaErrorOverlay.js
// module id = 2010
// module chunks = 0